export const COSTS = {
  inputTokens: 6, // $6 per million tokens
  outputTokens: 30, // $30 per million tokens
  minutes: 2, // $2 per 60 minutes
}

export const calculateCost = (value, type) => {
  if (!value) return 0
  switch (type) {
    case 'inputTokens':
      return (value / 1000000) * COSTS.inputTokens
    case 'outputTokens':
      return (value / 1000000) * COSTS.outputTokens
    case 'minutes':
      return (value / 60) * COSTS.minutes
    default:
      return 0
  }
}

export const calculateTotalCost = details => {
  if (!details) return 0
  return (
    calculateCost(details.inputTokenLimit || 0, 'inputTokens') +
    calculateCost(details.outputTokenLimit || 0, 'outputTokens') +
    calculateCost(details.minuteLimit || 0, 'minutes')
  )
}
